<template>
  <ex-card disable-offsets class="product_list_table">
    <template slot="header">
      <div v-for="(product, index) in selectedProductList" :key="index">
        <ProductDetailsInfo
          :product="product"
          :index="index"
          @chooseProduct="
            (isChecked, productId) =>
              $emit('chooseProduct', isChecked, productId)
          "
          @removeProductFromSelected="
            $emit('removeProductFromSelected', $event)
          "
          @filterDomainSellers="$emit('filterDomainSellers', $event, index)"
          @addUrlToProduct="$emit('addUrlToProduct')"
          @extractProduct="(payload) => $emit('extractProduct', payload)"
        />
        <ProductDetailsTable
          ref="ProductDetailsTable"
          :selected="selected"
          :product="product"
          :productInfo="productInfo"
          :productsData="productsData"
          @parentProduct="parentProduct"
          @selectItem="selectItem"
          @selectSeller="selectSeller"
          @showPreviousProduct="$emit('showPreviousProduct', $event)"
          @showNextProduct="$emit('showNextProduct', $event)"
        />
      </div>
      <!--      <div class="d-flex align-center">-->
      <!--        <v-radio-group @change="updateProductList()" ref="radioGroup" :value="selectedProductList.clients[0].client_name" row class="mt-0 pa-0" hide-details>-->
      <!--          <v-radio :label="selectedProductList.clients[0].client_name" value="0" :ripple="false" color="primary" class="i-v-radio light"></v-radio>-->
      <!--        </v-radio-group>-->
      <!--        <v-btn-->
      <!--          text-->
      <!--          :ripple="false"-->
      <!--          class="ex-btn ex-primary-btn"-->
      <!--          @click="createProduct()"-->
      <!--        >-->
      <!--          <v-icon>add</v-icon>-->
      <!--        </v-btn>-->
      <!--      </div>-->
    </template>
    <v-dialog v-model="deleteDialog" persistent max-width="400">
      <v-card>
        <v-card-title class="headline">Deleting, are you sure?</v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="deleteDialog = false"
          >
            No
          </v-btn>
          <v-btn
            text
            :ripple="false"
            :loading="loading"
            class="ex-btn ex-primary-btn text--white"
            @click="confirmDeleteLink()"
          >
            Yes
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </ex-card>
</template>

<script>
/* eslint-disable */
import ProductDetailsHeader from "./ProductDetailsHeader";
import ProductDetailsInfo from "./ProductDetailsInfo";
import ProductDetailsTable from "./ProductDetailsTable";

export default {
  name: "ProductTable",
  components: {
    ProductDetailsHeader,
    ProductDetailsInfo,
    ProductDetailsTable,
  },
  props: {
    selectedProductList: {
      type: [Object, Array],
      default: null,
    },
    selectVariation: {
      type: [Object, Array],
      default: null,
    },
    trackIds: {
      type: [Object, Array],
      default: null,
    },
    urlIds: {
      type: [Object, Array],
      default: null,
    },
    deleteUrlPayload: {
      type: Object,
      default: null,
    },
    productInfo: {
      type: [Object, Array],
      default: null,
    },
    productsData: {
      type: [Object, Array],
      default: null,
    },
  },
  data: () => ({
    loading: false,
    dialog: false,
    linkDialog: false,
    deleteDialog: false,
    trackId: [],
    selected: [],
  }),
  mounted() {
    console.log("SELECTED PRODUCTs", this.selectedProductList);
  },
  methods: {
    parentProduct(id) { // alert(id)
      this.$emit('parentProduct',id);
      //this.$parent.loadProduct(id);
    },
    test(product) {
      console.log("this.selectedProductList", product);
    },
    updateProductList() {
      let coped = JSON.stringify(this.selectedProductList);
      let copyObject = JSON.parse(coped);
      let trackIds = [];
      let arr = [];
      copyObject.clients.forEach((el, index) => {
        el.tracks.map((el) => trackIds.push(el.track_id));
      });
      copyObject.tracks.map((copyEl) => {
        let tracksItems = copyEl;
        copyEl.urls.map((el) => {
          let urls = [];
          trackIds.forEach((checkElement) => {
            if (el.track_id === checkElement) {
              urls.push(el);
              let createCheckedObj = {
                urls,
                color: 1,
                seller_id: tracksItems.seller_id,
                seller_name: tracksItems.seller_name,
              };
              arr.push(createCheckedObj);
            }
          });
        });
      });
      this.selectedProductList.tracks = arr;
    },
    selectItem({ trackId, urlId, domainId, productId }) {
      const mainCheckbox = document.getElementById(domainId);
      const allCheckbox = document.querySelectorAll(`.domain_${domainId}`);

      for (const checkbox of allCheckbox) {
        if (!checkbox.checked) {
          mainCheckbox.checked = false;
          break;
        }
        mainCheckbox.checked = true;
      }
      this.$emit("createPayloadLinkFromClients", trackId, urlId);
    },
    selectSeller(e, domains) {
      // const isChecked = e.target.checked
      this.checkAllOfCurrentTable(e.target);
      domains.forEach((domain) => {
        domain.sellers.forEach((seller) => {
          this.$emit(
            "createPayloadLinkFromClients",
            seller.track_id,
            domain.url_id
          );
        });
      });
    },
    checkAllOfCurrentTable(target) {
      const elements = target
        .closest(".domain_table")
        .querySelectorAll(".track_checkbox");
      // console.log(this.$refs.ProductDetailsTable)
      elements.forEach((el) => {
        // el.checked = target.checked
        this.$set(el, "checked", target.checked);
        // console.log(childCheckbox)
      });
    },
    onCheckedAll(isChecked) {
      const elements = document.querySelectorAll(".track_checkbox");
      elements.forEach((element) => {
        if (isChecked) {
          if (element.checked) return;
          element.checked = true;
        } else {
          element.checked = false;
        }
      });
    },
    callSelectedAll(e) {
      let input = document.getElementsByClassName("custom-checkbox");
      if (e.target.checked) {
        this.trackIds = [];
        this.selectedProductList.tracks.map((el) => {
          el.urls.map((elem) => {
            this.trackIds.push(elem.track_id);
          });
        });
        Array.from(input).forEach((el) => {
          el.checked = true;
        });
      } else {
        this.trackIds = [];
        Array.from(input).forEach((el) => {
          el.checked = false;
        });
      }
    },
    createProduct() {
      this.$emit("createProduct");
    },
    confirmDelete() {
      this.loading = true;
      this.dialog = false;
      this.$store
        .dispatch("productModule/deleteRowOfProductList", this.productInfo)
        .then((res) => {
          console.log("deleteRowOfProductList", res);
          this.loading = false;
        });
    },
    confirmDeleteLink() {
      this.$emit("deleteLinks", this.trackId);
      this.deleteDialog = false;
    },
    deleteLink(trackId) {
      this.trackId = [trackId];
      this.deleteDialog = true;
    },
  },
};
</script>

<style scoped>
.product_info_content {
  flex-wrap: wrap;
}

.product_info_content > .product_info > p:first-child {
  border-bottom: 1px solid;
}
</style>



// WEBPACK FOOTER //
// src/components/product/ProductTable.vue